import React, { useCallback, useEffect, useState } from "react";
import styles from "./Home.module.css";
import Footer from "../../components/ui/Footer";
import Navbar from "../../components/ui/Navbar";
import Menu from "../../components/ui/Menu";
import BirthdayModal from "../../components/ui/BirthdayModal";
import Auth from "../../utils/api/Auth";
import { useDispatch, useSelector } from "react-redux";
import { userDataActions } from "../../store/redux-store/Index";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FixedAgent from "../../utils/api/FixedAgent";

// Airtable config variables (fill these in with your actual values)
const AIRTABLE_API_KEY =
  "patwe30rgDHnof9jA.2a4b1c64545df33554b67962be0d5325972be52a32a04b98eef7d8ffea836fd7";
const AIRTABLE_BASE_ID = "appvoJCqzTCF8SWzo";
const AIRTABLE_FRAUD_EMAILS_TABLE_ID = "customers";
const AIRTABLE_BANNER_TABLE_ID = "content";

function Home(props) {
  const [userDetails, setUserDetails] = useState([]);
  const [historyLength, setHistoryLength] = useState(0);

  const [customerStatus, setCustomerStatus] = useState({
    active: 0,
    dueSoon: 0,
    expired: 0,
  });

  const [customerPapers, setCustomerPapers] = useState({
    road: 0,
    vl: 0,
    insurance: 0,
  });

  const [customerPapersSales, setCustomerPapersSales] = useState({
    road: 0,
    vl: 0,
    insurance: 0,
  });

  const token = useSelector((state) => state.userData.loginData.token);

  const user = useSelector((state) => state.userData.personalInfo);

  const dispatch = useDispatch();

  const [showBanner, setShowBanner] = useState(true);

  const [fraudEmails, setFraudEmails] = useState([]);
  // const [bannerContent, setBannerContent] = useState("");
  const [fraudEmailRecords, setFraudEmailRecords] = useState([]); // Store full records
  const [bannerRecords, setBannerRecords] = useState([]); // Store full records
  const [showBirthdayModal, setShowBirthdayModal] = useState(false);

  const currentEmail = user?.email || userDetails?.email;

  const closeMenuHandler = () => {
    props.setShowMenu(false);
  };

  useEffect(() => {
    const fetchHistoryList = async () => {
      try {
        const historyListRes = await FixedAgent.getManualOrderHistory({
          token,
        });
        setHistoryLength(historyListRes.data.data.length);
      } catch (err) {
        toast.error(err?.response?.data?.message, {
          position: "top-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }
    };
    fetchHistoryList();
  }, [token]);

  const fetchCustomers = useCallback(async () => {
    try {
      setCustomerStatus({
        active: 0,
        dueSoon: 0,
        expired: 0,
      });
      const response = await FixedAgent.getAllCustomers({ token });
      response?.data?.data?.forEach((customer, index) => {
        checkCustomerStatus(customer);
      });
    } catch (error) {
      toast.error(error?.response?.data?.message, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      console.error("Failed to fetch customers", error);
    }
  }, [token]);

  useEffect(() => {
    fetchCustomers();
  }, [fetchCustomers]);

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const userRes = await Auth.getUserInfo({ token: token });
        setUserDetails(userRes.data.user[0]);
        dispatch(userDataActions.generalUserData(userRes.data.user[0]));
      } catch (err) {
        toast.error(err?.response?.data?.message, {
          position: "top-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
          style: {
            backgroundColor: "#FFFFFF",
            color: "#000000",
          },
        });
      }
    };
    fetchUserDetails();
  }, [token, dispatch]);

  useEffect(() => {
    const checkAgentBirthday = async () => {
      try {
        const response = await Auth.getAgentBirthday();
        const agentRecords = response.data.records;
        
        const loggedInUserEmail = user?.email || userDetails?.email;
        
        if (!loggedInUserEmail) {
          return;
        }

        // Check if user's email exists in Airtable records
        const userRecordExists = agentRecords.some(
          (record) =>
            record.fields.email &&
            record.fields.email.toLowerCase() === loggedInUserEmail.toLowerCase()
        );

        // If record doesn't exist, show modal to collect information
        if (!userRecordExists) {
          setShowBirthdayModal(true);
        }
      } catch (err) {
        console.error("Failed to fetch agent birthday data", err);
      }
    };

    if (user?.email || userDetails?.email) {
      checkAgentBirthday();
    }
  }, [user?.email, userDetails?.email]);

  useEffect(() => {
    const fetchFraudEmails = async () => {
      try {
        const res = await fetch(
          `https://api.airtable.com/v0/${AIRTABLE_BASE_ID}/${AIRTABLE_FRAUD_EMAILS_TABLE_ID}`,
          {
            headers: {
              Authorization: `Bearer ${AIRTABLE_API_KEY}`,
            },
          }
        );
        const data = await res.json();
        // Store full records for group lookup
        setFraudEmailRecords(data.records);
        const emails = data.records
          .map((rec) => rec.fields.email)
          .filter(Boolean);
        setFraudEmails(emails);
      } catch (err) {
        setFraudEmails([user?.email || userDetails?.email]);
        setFraudEmailRecords([]);
      }
    };

    const fetchBannerContent = async () => {
      try {
        const res = await fetch(
          `https://api.airtable.com/v0/${AIRTABLE_BASE_ID}/${AIRTABLE_BANNER_TABLE_ID}`,
          {
            headers: {
              Authorization: `Bearer ${AIRTABLE_API_KEY}`,
            },
          }
        );
        const data = await res.json();
        setBannerRecords(data.records); // Store all banner records
        if (data.records && data.records.length > 0) {
          // setBannerContent(data.records[0].fields.content); // fallback for legacy logic
        }
      } catch (err) {
        // setBannerContent(
        //   "⚠️ Please do not transact with this distributor anymore due to a fraud alert."
        // );
        setBannerRecords([]);
      }
    };

    fetchFraudEmails();
    fetchBannerContent();
  }, [user?.email, userDetails?.email]);

  const getEmailGroup = (email) => {
    const rec = fraudEmailRecords.find(
      (rec) =>
        rec.fields.email &&
        rec.fields.email.toLowerCase() === email?.toLowerCase()
    );
    return rec?.fields?.group || null;
  };

  const getBannerGroup = (bannerRec) => bannerRec?.fields?.group || null;

  let matchedBannerContent = null;
  // let matchedBannerGroup = null;
  let userGroup = getEmailGroup(currentEmail);
  if (userGroup && bannerRecords.length > 0) {
    const match = bannerRecords.find(
      (rec) => getBannerGroup(rec) && getBannerGroup(rec) === userGroup
    );
    if (match) {
      matchedBannerContent = match.fields.content;
      // matchedBannerGroup = match.fields.group;
    }
  }

  const checkCustomerStatus = (customer) => {
    const parseDate = (dateStr) => {
      if (dateStr.includes("/")) {
        let [day, month, year] = dateStr.split("/").map((part) => part.trim());

        if (year.length === 2) {
          year = parseInt(year) < 50 ? "20" + year : "19" + year;
        }

        return new Date(`${year}-${month}-${day}`).getTime();
      } else if (dateStr.includes("-")) {
        return new Date(dateStr).getTime();
      } else {
        throw new Error("Invalid date format");
      }
    };

    const currentDate = new Date().getTime();
    const roadDueDate = customer.road_expiry_date
      ? parseDate(customer.road_expiry_date)
      : null;
    const vlDueDate = customer.vl_expiry_date
      ? parseDate(customer.vl_expiry_date)
      : null;
    const insuranceDueDate = customer.expiry_date
      ? parseDate(customer.expiry_date)
      : null;
    const insuranceIssueDate = customer.issue_date
      ? parseDate(customer.issue_date)
      : null;
    const vlIssueDate = customer.vl_issue_date
      ? parseDate(customer.vl_issue_date)
      : null;

    if (roadDueDate !== null) {
      if (
        new Date(roadDueDate).getMonth() === new Date(currentDate).getMonth() &&
        new Date(roadDueDate).getFullYear() ===
          new Date(currentDate).getFullYear()
      ) {
        setCustomerPapers((prevPapers) => ({
          ...prevPapers,
          road: prevPapers.road + 1,
        }));
      }

      if (roadDueDate < currentDate) {
        setCustomerStatus((prevStatus) => ({
          ...prevStatus,
          expired: prevStatus.expired + 1,
        }));
      } else if (roadDueDate - currentDate <= 30 * 24 * 60 * 60 * 1000) {
        setCustomerStatus((prevStatus) => ({
          ...prevStatus,
          dueSoon: prevStatus.dueSoon + 1,
        }));
      } else if (roadDueDate > currentDate) {
        setCustomerStatus((prevStatus) => ({
          ...prevStatus,
          active: prevStatus.active + 1,
        }));
      }
    }

    if (vlDueDate !== null) {
      if (
        new Date(vlDueDate).getMonth() === new Date(currentDate).getMonth() &&
        new Date(vlDueDate).getFullYear() ===
          new Date(currentDate).getFullYear()
      ) {
        setCustomerPapers((prevPapers) => ({
          ...prevPapers,
          vl: prevPapers.vl + 1,
        }));
      }

      if (vlDueDate < currentDate) {
        setCustomerStatus((prevStatus) => ({
          ...prevStatus,
          expired: prevStatus.expired + 1,
        }));
      } else if (vlDueDate - currentDate <= 30 * 24 * 60 * 60 * 1000) {
        setCustomerStatus((prevStatus) => ({
          ...prevStatus,
          dueSoon: prevStatus.dueSoon + 1,
        }));
      } else if (vlDueDate > currentDate) {
        setCustomerStatus((prevStatus) => ({
          ...prevStatus,
          active: prevStatus.active + 1,
        }));
      }
    }

    if (insuranceDueDate !== null) {
      if (
        new Date(insuranceDueDate).getMonth() ===
          new Date(currentDate).getMonth() &&
        new Date(insuranceDueDate).getFullYear() ===
          new Date(currentDate).getFullYear()
      ) {
        setCustomerPapers((prevPapers) => ({
          ...prevPapers,
          insurance: prevPapers.insurance + 1,
        }));
      }

      if (insuranceDueDate < currentDate) {
        setCustomerStatus((prevStatus) => ({
          ...prevStatus,
          expired: prevStatus.expired + 1,
        }));
      } else if (insuranceDueDate - currentDate <= 30 * 24 * 60 * 60 * 1000) {
        setCustomerStatus((prevStatus) => ({
          ...prevStatus,
          dueSoon: prevStatus.dueSoon + 1,
        }));
      } else if (insuranceDueDate > currentDate) {
        setCustomerStatus((prevStatus) => ({
          ...prevStatus,
          active: prevStatus.active + 1,
        }));
      }
    }

    if (insuranceIssueDate !== null) {
      if (
        new Date(insuranceIssueDate).getMonth() ===
          new Date(currentDate).getMonth() &&
        new Date(insuranceIssueDate).getFullYear() ===
          new Date(currentDate).getFullYear()
      ) {
        setCustomerPapersSales((prevPapersSales) => ({
          ...prevPapersSales,
          insurance: prevPapersSales.insurance + 1,
        }));
      }
    }

    if (vlIssueDate !== null) {
      if (
        new Date(vlIssueDate).getMonth() === new Date(currentDate).getMonth() &&
        new Date(vlIssueDate).getFullYear() ===
          new Date(currentDate).getFullYear()
      ) {
        setCustomerPapersSales((prevPapersSales) => ({
          ...prevPapersSales,
          vl: prevPapersSales.vl + 1,
        }));
      }
    }
  };

  const greetUser = () => {
    const currentTime = new Date().getHours();
    if (currentTime < 12) {
      return "Good Morning";
    } else if (currentTime < 18) {
      return "Good Afternoon";
    } else {
      return "Good Evening";
    }
  };

  const handleCloseBirthdayModal = () => {
    setShowBirthdayModal(false);
  };

  return (
    <div>
      <ToastContainer />
      <BirthdayModal
        show={showBirthdayModal}
        onClose={handleCloseBirthdayModal}
        userName={user?.fullname || userDetails?.fullname}
        userEmail={currentEmail}
      />
      <div className="menu" onClick={closeMenuHandler}>
        {props.showMenu && <Menu setShowMenu={props.setShowMenu} />}
      </div>
      <Navbar title="Dashboard" setShowMenu={props.setShowMenu} />
      <div className={styles.body}>
        <div className={styles.body_inner}>
          {showBanner &&
            matchedBannerContent &&
            fraudEmails.includes(currentEmail) && (
              <div
                className={styles.fraudBanner}
                style={{
                  background: "#fff3cd",
                  color: "#856404",
                  border: "1px solid #ffeeba",
                  padding: "12px 16px",
                  borderRadius: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  fontWeight: 500,
                  fontSize: "15px",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                  margin: 0,
                  marginBottom: 16,
                  zIndex: 10,
                  width: "100%",
                }}
              >
                <span>{matchedBannerContent}</span>
                <button
                  onClick={() => setShowBanner(false)}
                  style={{
                    background: "none",
                    border: "none",
                    color: "#856404",
                    fontSize: "18px",
                    cursor: "pointer",
                    marginLeft: "16px",
                    display: "flex",
                    alignItems: "center",
                    padding: 0,
                  }}
                  aria-label="Close warning banner"
                >
                  ×
                </button>
              </div>
            )}
          <h1 className={styles.body_inner_header}>
            {greetUser()} {user?.fullname || userDetails?.fullname}.
          </h1>
          <div className={styles.body_inner_card}>
            <p className={styles.card_p}>
              {new Date().toLocaleString("default", { month: "long" })}
            </p>
            <div className={styles.body_inner_text_wrapper}>
              <p className={styles.card_p}>Due: </p>
              <h1 className={styles.card_h1}>
                ₦
                {Number(
                  customerPapers?.road * 6500 +
                    customerPapers?.insurance * 15000 +
                    customerPapers.vl * 4500
                ).toLocaleString()}{" "}
              </h1>
            </div>

            <div className={styles.body_inner_text_wrapper}>
              <p className={styles.card_p}>Sales: </p>
              <h1 className={styles.card_h1}>
                ₦
                {Number(
                  customerPapersSales?.road * 6500 +
                    customerPapersSales?.insurance * 15000 +
                    customerPapersSales.vl * 4500
                ).toLocaleString() || 0}
              </h1>
            </div>
            <p className={styles.card_p}>Sales progress for the month</p>
          </div>
        </div>

        <h1 className={styles.body_inner_header}>Reward</h1>

        <div className={styles.reward}>
          <h1>Free PIN Meter</h1>
          <div className={styles.reward_inner}>
            <div className={styles.meter}>
              <div
                className={styles.meter_track}
                style={{
                  width: "100%",
                  height: "10px",
                  backgroundColor: "#F4F7FF",
                  borderRadius: "10px",
                  position: "relative",
                }}
              >
                <div
                  className={styles.meter_fill}
                  style={{
                    width: `${
                      historyLength % 30 === 0 && historyLength > 0
                        ? 100
                        : ((historyLength % 30) / 30) * 100
                    }%`,
                    backgroundColor: "#7E7CF1",
                    height: "10px",
                    borderRadius: "10px",
                  }}
                ></div>
                {historyLength % 30 !== 0 && (
                  <h1
                    style={{
                      position: "absolute",
                      left: `${((historyLength % 30) / 30) * 100}%`,
                      transform: "translateX(-50%)",
                      top: "-25px",
                    }}
                  >
                    {historyLength % 30}
                  </h1>
                )}
                <h1
                  style={{
                    position: "absolute",
                    left: "0%",
                    transform: "translateX(0%)",
                    top: "-25px",
                  }}
                >
                  0
                </h1>
                <h1
                  style={{
                    position: "absolute",
                    left: "100%",
                    transform: "translateX(-50%)",
                    top: "-25px",
                  }}
                >
                  30
                </h1>
              </div>
            </div>
          </div>
          <p>Get one Free PIN for every 30 renewals.</p>
        </div>

        <div className={styles.transaction}>
          <div
            className={styles.transaction_card}
            style={{ border: "1px solid #37CE7F" }}
          >
            <div
              className={styles.transaction_card_number}
              style={{ backgroundColor: "#37CE7F33" }}
            >
              <p style={{ color: "#03C962" }}>{customerStatus?.active}</p>
            </div>
            <div className={styles.transaction_card_text}>
              <h1>Active Customers</h1>
            </div>
          </div>

          <div
            className={styles.transaction_card}
            style={{ border: "1px solid #FBB31933" }}
          >
            <div
              className={styles.transaction_card_number}
              style={{ backgroundColor: "#FBB31933" }}
            >
              <p style={{ color: "#FBB319" }}>{customerStatus?.dueSoon}</p>
            </div>
            <div className={styles.transaction_card_text}>
              <h1>Expiring Soon</h1>
            </div>
          </div>

          <div
            className={styles.transaction_card}
            style={{ border: "1px solid #FF0B0B" }}
          >
            <div
              className={styles.transaction_card_number}
              style={{ backgroundColor: "#FFCECE" }}
            >
              <p style={{ color: "#FF0B0B" }}>{customerStatus?.expired}</p>
            </div>
            <div className={styles.transaction_card_text}>
              <h1>Expired</h1>
            </div>
          </div>
        </div>

        {/* <div className={styles.vehicle_products}>
            <div className={styles.vehicle_products_card}>Vehicle License</div>

            <div className={styles.vehicle_products_card}>Road Worth...</div>

            <div className={styles.vehicle_products_card}>Bill Payment</div>

            <div className={styles.vehicle_products_card}>Survey</div>
          </div> */}
      </div>
      <Footer />
    </div>
    // </div>
  );
}

export default Home;
